import { useCollectionData } from "react-firebase-hooks/firestore";
import { auth, firestore } from "hooks/useFirebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { collection, query, where, limit } from "firebase/firestore";

export const useFirebaseRef = () => {
  return collection(firestore, "settings/admin/AuthorizedMeetingUsers");
};

export const useAuthorizedUserByEmail = () => {
  const [authUser] = useAuthState(auth);

  const collectionRef = useFirebaseRef();
  
  // Create a query only if authUser exists and has an email
  const userQuery = authUser?.email ? 
    query(
      collectionRef, 
      where("email", "==", authUser.email),
      limit(1)
    ) : null;
  
  let [users, loading, error] = useCollectionData(
    userQuery,
    {
      idField: "id",
    }
  );

  return { user: users?.[0], loading, error, authUser };
};
